import { render } from "./index.vue?vue&type=template&id=708e2832"
const script = {}
script.render = render

export default script